const countries = [
  { label: 'Afghanistan', value: 'AF', text: 'Afghanistan' },
  { label: 'Åland Islands', value: 'AX', text: 'Åland Islands' },
  { label: 'Albania', value: 'AL', text: 'Albania' },
  { label: 'Algeria', value: 'DZ', text: 'Algeria' },
  { label: 'American Samoa', value: 'AS', text: 'American Samoa' },
  { label: 'AndorrA', value: 'AD', text: 'AndorrA' },
  { label: 'Angola', value: 'AO', text: 'Angola' },
  { label: 'Anguilla', value: 'AI', text: 'Anguilla' },
  { label: 'Antarctica', value: 'AQ', text: 'Antarctica' },
  { label: 'Antigua and Barbuda', value: 'AG', text: 'Antigua and Barbuda' },
  { label: 'Argentina', value: 'AR', text: 'Argentina' },
  { label: 'Armenia', value: 'AM', text: 'Armenia' },
  { label: 'Aruba', value: 'AW', text: 'Aruba' },
  { label: 'Australia', value: 'AU', text: 'Australia' },
  { label: 'Austria', value: 'AT', text: 'Austria' },
  { label: 'Azerbaijan', value: 'AZ', text: 'Azerbaijan' },
  { label: 'Bahamas', value: 'BS', text: 'Bahamas' },
  { label: 'Bahrain', value: 'BH', text: 'Bahrain' },
  { label: 'Bangladesh', value: 'BD', text: 'Bangladesh' },
  { label: 'Barbados', value: 'BB', text: 'Barbados' },
  { label: 'Belarus', value: 'BY', text: 'Belarus' },
  { label: 'Belgium', value: 'BE', text: 'Belgium' },
  { label: 'Belize', value: 'BZ', text: 'Belize' },
  { label: 'Benin', value: 'BJ', text: 'Benin' },
  { label: 'Bermuda', value: 'BM', text: 'Bermuda' },
  { label: 'Bhutan', value: 'BT', text: 'Bhutan' },
  { label: 'Bolivia', value: 'BO', text: 'Bolivia' },
  {
    label: 'Bosnia and Herzegovina',
    value: 'BA',
    text: 'Bosnia and Herzegovina',
  },
  { label: 'Botswana', value: 'BW', text: 'Botswana' },
  { label: 'Bouvet Island', value: 'BV', text: 'Bouvet Island' },
  { label: 'Brazil', value: 'BR', text: 'Brazil' },
  {
    label: 'British Indian Ocean Territory',
    value: 'IO',
    text: 'British Indian Ocean Territory',
  },
  { label: 'Brunei Darussalam', value: 'BN', text: 'Brunei Darussalam' },
  { label: 'Bulgaria', value: 'BG', text: 'Bulgaria' },
  { label: 'Burkina Faso', value: 'BF', text: 'Burkina Faso' },
  { label: 'Burundi', value: 'BI', text: 'Burundi' },
  { label: 'Cambodia', value: 'KH', text: 'Cambodia' },
  { label: 'Cameroon', value: 'CM', text: 'Cameroon' },
  { label: 'Canada', value: 'CA', text: 'Canada' },
  { label: 'Cape Verde', value: 'CV', text: 'Cape Verde' },
  { label: 'Cayman Islands', value: 'KY', text: 'Cayman Islands' },
  {
    label: 'Central African Republic',
    value: 'CF',
    text: 'Central African Republic',
  },
  { label: 'Chad', value: 'TD', text: 'Chad' },
  { label: 'Chile', value: 'CL', text: 'Chile' },
  { label: 'China', value: 'CN', text: 'China' },
  { label: 'Christmas Island', value: 'CX', text: 'Christmas Island' },
  {
    label: 'Cocos (Keeling) Islands',
    value: 'CC',
    text: 'Cocos (Keeling) Islands',
  },
  { label: 'Colombia', value: 'CO', text: 'Colombia' },
  { label: 'Comoros', value: 'KM', text: 'Comoros' },
  { label: 'Congo', value: 'CG', text: 'Congo' },
  {
    label: 'Congo, The Democratic Republic of the',
    value: 'CD',
    text: 'Congo, The Democratic Republic of the',
  },
  { label: 'Cook Islands', value: 'CK', text: 'Cook Islands' },
  { label: 'Costa Rica', value: 'CR', text: 'Costa Rica' },
  { label: 'Cote D"Ivoire', value: 'CI', text: 'Cote D"Ivoire' },
  { label: 'Croatia', value: 'HR', text: 'Croatia' },
  { label: 'Cuba', value: 'CU', text: 'Cuba' },
  { label: 'Cyprus', value: 'CY', text: 'Cyprus' },
  { label: 'Czech Republic', value: 'CZ', text: 'Czech Republic' },
  { label: 'Denmark', value: 'DK', text: 'Denmark' },
  { label: 'Djibouti', value: 'DJ', text: 'Djibouti' },
  { label: 'Dominica', value: 'DM', text: 'Dominica' },
  { label: 'Dominican Republic', value: 'DO', text: 'Dominican Republic' },
  { label: 'Ecuador', value: 'EC', text: 'Ecuador' },
  { label: 'Egypt', value: 'EG', text: 'Egypt' },
  { label: 'El Salvador', value: 'SV', text: 'El Salvador' },
  { label: 'Equatorial Guinea', value: 'GQ', text: 'Equatorial Guinea' },
  { label: 'Eritrea', value: 'ER', text: 'Eritrea' },
  { label: 'Estonia', value: 'EE', text: 'Estonia' },
  { label: 'Ethiopia', value: 'ET', text: 'Ethiopia' },
  {
    label: 'Falkland Islands (Malvinas)',
    value: 'FK',
    text: 'Falkland Islands (Malvinas)',
  },
  { label: 'Faroe Islands', value: 'FO', text: 'Faroe Islands' },
  { label: 'Fiji', value: 'FJ', text: 'Fiji' },
  { label: 'Finland', value: 'FI', text: 'Finland' },
  { label: 'France', value: 'FR', text: 'France' },
  { label: 'French Guiana', value: 'GF', text: 'French Guiana' },
  { label: 'French Polynesia', value: 'PF', text: 'French Polynesia' },
  {
    label: 'French Southern Territories',
    value: 'TF',
    text: 'French Southern Territories',
  },
  { label: 'Gabon', value: 'GA', text: 'Gabon' },
  { label: 'Gambia', value: 'GM', text: 'Gambia' },
  { label: 'Georgia', value: 'GE', text: 'Georgia' },
  { label: 'Germany', value: 'DE', text: 'Germany' },
  { label: 'Ghana', value: 'GH', text: 'Ghana' },
  { label: 'Gibraltar', value: 'GI', text: 'Gibraltar' },
  { label: 'Greece', value: 'GR', text: 'Greece' },
  { label: 'Greenland', value: 'GL', text: 'Greenland' },
  { label: 'Grenada', value: 'GD', text: 'Grenada' },
  { label: 'Guadeloupe', value: 'GP', text: 'Guadeloupe' },
  { label: 'Guam', value: 'GU', text: 'Guam' },
  { label: 'Guatemala', value: 'GT', text: 'Guatemala' },
  { label: 'Guernsey', value: 'GG', text: 'Guernsey' },
  { label: 'Guinea', value: 'GN', text: 'Guinea' },
  { label: 'Guinea-Bissau', value: 'GW', text: 'Guinea-Bissau' },
  { label: 'Guyana', value: 'GY', text: 'Guyana' },
  { label: 'Haiti', value: 'HT', text: 'Haiti' },
  {
    label: 'Heard Island and Mcdonald Islands',
    value: 'HM',
    text: 'Heard Island and Mcdonald Islands',
  },
  {
    label: 'Holy See (Vatican City State)',
    value: 'VA',
    text: 'Holy See (Vatican City State)',
  },
  { label: 'Honduras', value: 'HN', text: 'Honduras' },
  { label: 'Hong Kong', value: 'HK', text: 'Hong Kong' },
  { label: 'Hungary', value: 'HU', text: 'Hungary' },
  { label: 'Iceland', value: 'IS', text: 'Iceland' },
  { label: 'India', value: 'IN', text: 'India' },
  { label: 'Indonesia', value: 'ID', text: 'Indonesia' },
  {
    label: 'Iran, Islamic Republic Of',
    value: 'IR',
    text: 'Iran, Islamic Republic Of',
  },
  { label: 'Iraq', value: 'IQ', text: 'Iraq' },
  { label: 'Ireland', value: 'IE', text: 'Ireland' },
  { label: 'Isle of Man', value: 'IM', text: 'Isle of Man' },
  { label: 'Israel', value: 'IL', text: 'Israel' },
  { label: 'Italy', value: 'IT', text: 'Italy' },
  { label: 'Jamaica', value: 'JM', text: 'Jamaica' },
  { label: 'Japan', value: 'JP', text: 'Japan' },
  { label: 'Jersey', value: 'JE', text: 'Jersey' },
  { label: 'Jordan', value: 'JO', text: 'Jordan' },
  { label: 'Kazakhstan', value: 'KZ', text: 'Kazakhstan' },
  { label: 'Kenya', value: 'KE', text: 'Kenya' },
  { label: 'Kiribati', value: 'KI', text: 'Kiribati' },
  {
    label: "Korea, Democratic People'S Republic of",
    value: 'KP',
    text: "Korea, Democratic People'S Republic of",
  },
  { label: 'Korea, Republic of', value: 'KR', text: 'Korea, Republic of' },
  { label: 'Kuwait', value: 'KW', text: 'Kuwait' },
  { label: 'Kyrgyzstan', value: 'KG', text: 'Kyrgyzstan' },
  {
    label: "Lao People'S Democratic Republic",
    value: 'LA',
    text: "Lao People'S Democratic Republic",
  },
  { label: 'Latvia', value: 'LV', text: 'Latvia' },
  { label: 'Lebanon', value: 'LB', text: 'Lebanon' },
  { label: 'Lesotho', value: 'LS', text: 'Lesotho' },
  { label: 'Liberia', value: 'LR', text: 'Liberia' },
  {
    label: 'Libyan Arab Jamahiriya',
    value: 'LY',
    text: 'Libyan Arab Jamahiriya',
  },
  { label: 'Liechtenstein', value: 'LI', text: 'Liechtenstein' },
  { label: 'Lithuania', value: 'LT', text: 'Lithuania' },
  { label: 'Luxembourg', value: 'LU', text: 'Luxembourg' },
  { label: 'Macao', value: 'MO', text: 'Macao' },
  {
    label: 'Macedonia, The Former Yugoslav Republic of',
    value: 'MK',
    text: 'Macedonia, The Former Yugoslav Republic of',
  },
  { label: 'Madagascar', value: 'MG', text: 'Madagascar' },
  { label: 'Malawi', value: 'MW', text: 'Malawi' },
  { label: 'Malaysia', value: 'MY', text: 'Malaysia' },
  { label: 'Maldives', value: 'MV', text: 'Maldives' },
  { label: 'Mali', value: 'ML', text: 'Mali' },
  { label: 'Malta', value: 'MT', text: 'Malta' },
  { label: 'Marshall Islands', value: 'MH', text: 'Marshall Islands' },
  { label: 'Martinique', value: 'MQ', text: 'Martinique' },
  { label: 'Mauritania', value: 'MR', text: 'Mauritania' },
  { label: 'Mauritius', value: 'MU', text: 'Mauritius' },
  { label: 'Mayotte', value: 'YT', text: 'Mayotte' },
  { label: 'Mexico', value: 'MX', text: 'Mexico' },
  {
    label: 'Micronesia, Federated States of',
    value: 'FM',
    text: 'Micronesia, Federated States of',
  },
  { label: 'Moldova, Republic of', value: 'MD', text: 'Moldova, Republic of' },
  { label: 'Monaco', value: 'MC', text: 'Monaco' },
  { label: 'Mongolia', value: 'MN', text: 'Mongolia' },
  { label: 'Montserrat', value: 'MS', text: 'Montserrat' },
  { label: 'Morocco', value: 'MA', text: 'Morocco' },
  { label: 'Mozambique', value: 'MZ', text: 'Mozambique' },
  { label: 'Myanmar', value: 'MM', text: 'Myanmar' },
  { label: 'Namibia', value: 'NA', text: 'Namibia' },
  { label: 'Nauru', value: 'NR', text: 'Nauru' },
  { label: 'Nepal', value: 'NP', text: 'Nepal' },
  { label: 'Netherlands', value: 'NL', text: 'Netherlands' },
  { label: 'Netherlands Antilles', value: 'AN', text: 'Netherlands Antilles' },
  { label: 'New Caledonia', value: 'NC', text: 'New Caledonia' },
  { label: 'New Zealand', value: 'NZ', text: 'New Zealand' },
  { label: 'Nicaragua', value: 'NI', text: 'Nicaragua' },
  { label: 'Niger', value: 'NE', text: 'Niger' },
  { label: 'Nigeria', value: 'NG', text: 'Nigeria' },
  { label: 'Niue', value: 'NU', text: 'Niue' },
  { label: 'Norfolk Island', value: 'NF', text: 'Norfolk Island' },
  {
    label: 'Northern Mariana Islands',
    value: 'MP',
    text: 'Northern Mariana Islands',
  },
  { label: 'Norway', value: 'NO', text: 'Norway' },
  { label: 'Oman', value: 'OM', text: 'Oman' },
  { label: 'Pakistan', value: 'PK', text: 'Pakistan' },
  { label: 'Palau', value: 'PW', text: 'Palau' },
  {
    label: 'Palestinian Territory, Occupied',
    value: 'PS',
    text: 'Palestinian Territory, Occupied',
  },
  { label: 'Panama', value: 'PA', text: 'Panama' },
  { label: 'Papua New Guinea', value: 'PG', text: 'Papua New Guinea' },
  { label: 'Paraguay', value: 'PY', text: 'Paraguay' },
  { label: 'Peru', value: 'PE', text: 'Peru' },
  { label: 'Philippines', value: 'PH', text: 'Philippines' },
  { label: 'Pitcairn', value: 'PN', text: 'Pitcairn' },
  { label: 'Poland', value: 'PL', text: 'Poland' },
  { label: 'Portugal', value: 'PT', text: 'Portugal' },
  { label: 'Puerto Rico', value: 'PR', text: 'Puerto Rico' },
  { label: 'Qatar', value: 'QA', text: 'Qatar' },
  { label: 'Reunion', value: 'RE', text: 'Reunion' },
  { label: 'Romania', value: 'RO', text: 'Romania' },
  { label: 'Russian Federation', value: 'RU', text: 'Russian Federation' },
  { label: 'RWANDA', value: 'RW', text: 'RWANDA' },
  { label: 'Saint Helena', value: 'SH', text: 'Saint Helena' },
  {
    label: 'Saint Kitts and Nevis',
    value: 'KN',
    text: 'Saint Kitts and Nevis',
  },
  { label: 'Saint Lucia', value: 'LC', text: 'Saint Lucia' },
  {
    label: 'Saint Pierre and Miquelon',
    value: 'PM',
    text: 'Saint Pierre and Miquelon',
  },
  {
    label: 'Saint Vincent and the Grenadines',
    value: 'VC',
    text: 'Saint Vincent and the Grenadines',
  },
  { label: 'Samoa', value: 'WS', text: 'Samoa' },
  { label: 'San Marino', value: 'SM', text: 'San Marino' },
  {
    label: 'Sao Tome and Principe',
    value: 'ST',
    text: 'Sao Tome and Principe',
  },
  { label: 'Saudi Arabia', value: 'SA', text: 'Saudi Arabia' },
  { label: 'Senegal', value: 'SN', text: 'Senegal' },
  {
    label: 'Serbia and Montenegro',
    value: 'CS',
    text: 'Serbia and Montenegro',
  },
  { label: 'Seychelles', value: 'SC', text: 'Seychelles' },
  { label: 'Sierra Leone', value: 'SL', text: 'Sierra Leone' },
  { label: 'Singapore', value: 'SG', text: 'Singapore' },
  { label: 'Slovakia', value: 'SK', text: 'Slovakia' },
  { label: 'Slovenia', value: 'SI', text: 'Slovenia' },
  { label: 'Solomon Islands', value: 'SB', text: 'Solomon Islands' },
  { label: 'Somalia', value: 'SO', text: 'Somalia' },
  { label: 'South Africa', value: 'ZA', text: 'South Africa' },
  {
    label: 'South Georgia and the South Sandwich Islands',
    value: 'GS',
    text: 'South Georgia and the South Sandwich Islands',
  },
  { label: 'Spain', value: 'ES', text: 'Spain' },
  { label: 'Sri Lanka', value: 'LK', text: 'Sri Lanka' },
  { label: 'Sudan', value: 'SD', text: 'Sudan' },
  { label: 'Surilabel', value: 'SR', text: 'Surilabel' },
  {
    label: 'Svalbard and Jan Mayen',
    value: 'SJ',
    text: 'Svalbard and Jan Mayen',
  },
  { label: 'Swaziland', value: 'SZ', text: 'Swaziland' },
  { label: 'Sweden', value: 'SE', text: 'Sweden' },
  { label: 'Switzerland', value: 'CH', text: 'Switzerland' },
  { label: 'Syrian Arab Republic', value: 'SY', text: 'Syrian Arab Republic' },
  {
    label: 'Taiwan, Province of China',
    value: 'TW',
    text: 'Taiwan, Province of China',
  },
  { label: 'Tajikistan', value: 'TJ', text: 'Tajikistan' },
  {
    label: 'Tanzania, United Republic of',
    value: 'TZ',
    text: 'Tanzania, United Republic of',
  },
  { label: 'Thailand', value: 'TH', text: 'Thailand' },
  { label: 'Timor-Leste', value: 'TL', text: 'Timor-Leste' },
  { label: 'Togo', value: 'TG', text: 'Togo' },
  { label: 'Tokelau', value: 'TK', text: 'Tokelau' },
  { label: 'Tonga', value: 'TO', text: 'Tonga' },
  { label: 'Trinidad and Tobago', value: 'TT', text: 'Trinidad and Tobago' },
  { label: 'Tunisia', value: 'TN', text: 'Tunisia' },
  { label: 'Turkey', value: 'TR', text: 'Turkey' },
  { label: 'Turkmenistan', value: 'TM', text: 'Turkmenistan' },
  {
    label: 'Turks and Caicos Islands',
    value: 'TC',
    text: 'Turks and Caicos Islands',
  },
  { label: 'Tuvalu', value: 'TV', text: 'Tuvalu' },
  { label: 'Uganda', value: 'UG', text: 'Uganda' },
  { label: 'Ukraine', value: 'UA', text: 'Ukraine' },
  { label: 'United Arab Emirates', value: 'AE', text: 'United Arab Emirates' },
  { label: 'United Kingdom', value: 'GB', text: 'United Kingdom' },
  { label: 'United States', value: 'US', text: 'United States' },
  {
    label: 'United States Minor Outlying Islands',
    value: 'UM',
    text: 'United States Minor Outlying Islands',
  },
  { label: 'Uruguay', value: 'UY', text: 'Uruguay' },
  { label: 'Uzbekistan', value: 'UZ', text: 'Uzbekistan' },
  { label: 'Vanuatu', value: 'VU', text: 'Vanuatu' },
  { label: 'Venezuela', value: 'VE', text: 'Venezuela' },
  { label: 'Viet Nam', value: 'VN', text: 'Viet Nam' },
  {
    label: 'Virgin Islands, British',
    value: 'VG',
    text: 'Virgin Islands, British',
  },
  { label: 'Virgin Islands, U.S.', value: 'VI', text: 'Virgin Islands, U.S.' },
  { label: 'Wallis and Futuna', value: 'WF', text: 'Wallis and Futuna' },
  { label: 'Western Sahara', value: 'EH', text: 'Western Sahara' },
  { label: 'Yemen', value: 'YE', text: 'Yemen' },
  { label: 'Zambia', value: 'ZM', text: 'Zambia' },
  { label: 'Zimbabwe', value: 'ZW', text: 'Zimbabwe' },
];
export { countries };
